import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { Divider } from 'antd';
import invoiceValidateRoutes from '../../Invoice.validateRoutes';
import InvoiceButtonsRepeated from '../InvoiceButtonsRepeated';
import DirectSaleProvider from '@/pages/MovementsPage/DirectSalePage/DirectSaleProvider';
import InvoiceNoteItemsGeneralTable from '@/components/Fiscal/Invoice/InvoiceForms/InvoiceNoteItemsGeneralForm/InvoiceNoteItemsGeneralTable';
import InvoiceItemValues from '@/components/Fiscal/Invoice/InvoiceForms/InvoiceNoteItemsGeneralForm/InvoiceNoteItemsGeneralTable/InvoiceItemValues';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import InvoiceDeleteButton from '@/components/_common/InvoiceDeleteButton';

export default function InvoiceNoteItensPage({ route }: PageProps) {
  const intl = useIntl().formatMessage;
  const {
    handleSubmit,
    disabled,
    disabledFields,
    isLoading,
    invoiceId,
    invoice: { data: invoice, isLoading: invoiceIsLoading },
  } = useInvoiceFormContext();

  const {
    parent: { key },
  } = route.parent;

  return (
    <DefaultRouteTabs
      route={invoiceValidateRoutes(route, invoice?.situation)}
      permissions={route.permissions}
      baseKey={invoiceId}
      basePath={`/app/fiscal/invoice/${key}/${invoiceId}`}
      resourceNotFound={!invoice && !invoiceIsLoading}
      extra={
        <SpaceForButton>
          <InvoiceDeleteButton />

          <SaveButton
            block
            type="primary"
            onClick={handleSubmit}
            loading={isLoading}
            disabled={disabled || disabledFields}
          >
            {intl({ id: 'commons.entity.save' })}
          </SaveButton>
        </SpaceForButton>
      }
    >
      <Helmet
        title={intl({
          id: 'layout.menu.movement.fiscalReport.invoiceNoteItems',
        })}
      />

      <InvoiceItemValues />

      <InvoiceNoteItemsGeneralTable />

      <DirectSaleProvider />

      <Divider />

      <InvoiceButtonsRepeated />
    </DefaultRouteTabs>
  );
}
